/**
 * Minimal Student Dashboard for Testing
 * Simple component to test basic rendering
 */

import React from 'react';
import { Tile, Button, Tag } from '@carbon/react';
import { Dashboard, Trophy } from '@carbon/icons-react';

const StudentDashboardMinimal: React.FC = () => {
  console.log('[MINIMAL DASHBOARD] Component rendering...');

  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '24px' }}>
        <Dashboard size={32} style={{ marginRight: '8px' }} />
        Student Dashboard - Minimal Test
      </h1>

      <div style={{ marginBottom: '24px' }}>
        <Tile style={{ padding: '24px', marginBottom: '16px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '16px' }}>
            <Trophy size={24} style={{ marginRight: '8px' }} />
            Welcome to Your Learning Dashboard
          </h2>
          <p style={{ marginBottom: '16px', color: '#525252' }}>
            This is a minimal test of the student dashboard to verify component rendering.
          </p>
          <div style={{ marginBottom: '16px' }}>
            <Tag>Mathematics: 75% Complete</Tag>
          </div>
          <Button kind="primary">Start Learning</Button>
        </Tile>

        <Tile style={{ padding: '24px' }}>
          <h3 style={{ fontSize: '1.25rem', marginBottom: '16px' }}>Quick Stats</h3>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <Tag>5 Day Streak</Tag>
            <Tag>12 Achievements</Tag>
            <Tag>3 Pending</Tag>
          </div>
        </Tile>
      </div>

      <div>
        <h3 style={{ fontSize: '1.25rem', marginBottom: '16px' }}>Component Test Results</h3>
        <ul>
          <li>✅ React component mounting</li>
          <li>✅ Carbon Tile rendering</li>
          <li>✅ Carbon Button rendering</li>
          <li>✅ Carbon Tag rendering</li>
          <li>✅ Carbon Icons rendering</li>
        </ul>
      </div>
    </div>
  );
};

export default StudentDashboardMinimal;
